<template>
  <div id="app">
    <router-view></router-view>
    <notifications  position="bottom center" />
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style>
body.blue_bg {
    background: #ffd4d4;
}
.pink_bg {
    background: #ffd4d4;
}
.ag-blue .ag-header{
    font-weight: 200!important;
}
.ag-blue{
    font-size: 13px!important;
}
#app {
  font-family: 'Hiragino Kaku Gothic Pro', 'Meiryo', sans-serif, 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /*text-align: center;*/
  color: #2c3e50;
  /*margin-top: 60px;*/
}

@media (min-width: 992px){
  .container {
      width: 1020px!important;
  }
  .container_1020 {
      width: 1020px!important;
  }
  .container_1120 {
      width: 1120px!important;
  }
  .container_1220 {
      width: 1220px!important;
  }
  .container_1320 {
      width: 1320px!important;
  }
  .container_1420 {
      width: 1420px!important;
  }
  .container_1520 {
      width: 1520px!important;
  }
  .container_1620 {
      width: 1620px!important;
  }
  .container_1720 {
      width: 1720px!important;
  }
  .container_1820 {
      width: 1820px!important;
  }

}
@media (min-width: 992px){
  .container_auto {
      width: 990px!important;
  }
}
@media (min-width: 1080px){
  .container_auto {
      width: 1020px!important;
  }
}
@media (min-width: 1180px){
  .container_auto {
      width: 1120px!important;
  }
}
@media (min-width: 1280px){
  .container_auto {
      width: 1220px!important;
  }
}
@media (min-width: 1380px){
  .container_auto {
      width: 1320px!important;
  }
}
@media (min-width: 1480px){
  .container_auto {
      width: 1420px!important;
  }
}


.nav-tabs>li>a,
.nav-tabs>li>a:hover,
.nav-tabs>li>a:focus {
    background: rgb(210, 210, 210)!important;
    color: #000000!important
}

.nav-tabs>li.active>a,
.nav-tabs>li.active>a:hover,
.nav-tabs>li.active>a:focus {
    background: #5b9bd5!important;
    color: #000000!important
}

.nav-tabs {
    border-bottom: 2px solid #9bf!important;
}
.form-control{
  padding: 0px 6px 0px 6px;
}
.has-feedback .form-control {
    padding-right: 6px!important;
}
.limited-height-box{
    height: 24px!important;
    padding: 0px 6px 0px 6px!important;
}
</style>



// WEBPACK FOOTER //
// App.vue?16d5d9d6